import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";

const notiMessage = new NotiMessage("success");

const errorMessage = new NotiMessage("error");

//clear all state
const getDefaultState = () => {
  return {
    admin: {},
    isLoggedIn: false,
    isRoleProgram: false,
  };
};

//URL for admin module
const loginUrl = "/login";
const loginUserUrl = "your";
const changePasswordUrl = "your/changePassword";

const eachUrl = "admin/getEach?";
const allUrl = "admin/get?";
const storeUrl = "admin/store";
const updateUrl = "admin/update?";
const deleteUrl = "admin/delete?";

const state = {
  dialog: false,
  isLoggedIn: false,
  isRoleProgram: false,
  admin: {},
  admins: [],
  adminData: {},
  roles: [
    { id: 1, name: "Admin" },
    { id: 2, name: "Developer" },
    { id: 3, name: "M&E" },
    { id: 4, name: "Program" },
    { id: 5, name: "Clinic Manager" },
  ],
};
const getters = {};
const mutations = {
  SET_ROLE_PROGRAM(state) {
    state.isRoleProgram = !state.isRoleProgram;
  },
  CHANGE_DIALOG_STATE(state) {
    state.dialog = !state.dialog;
  },
  CHANGE_LOGGED_IN_STATUS(state) {
    state.isLoggedIn = !state.isLoggedIn;
  },
  SET_ADMIN(state, admin) {
    state.admin = admin.data.data.admin;
  },
  SET_ADMIN_DATA(state, adminData) {
    state.adminData = adminData.data.data;
  },
  SET_ADMINS(state, admins) {
    state.admins = admins.data.data;
  },
  ADD_ADMIN(state, payload) {
    state.admins.push(payload.data.data);
  },
  REMOVE_ADMIN(state, payload) {
    const admins = state.pas.filter((item) => item.id != payload.id);
    state.admins = [...admins];
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  setDialog({ commit }) {
    commit("CHANGE_DIALOG_STATE");
  },
  async getAdmin({ commit }) {
    const response = await Request.get_data(loginUserUrl);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("SET_ADMIN", response);
      const roleNumberType =
        typeof response.data.data.admin.role === "string"
          ? Number(response.data.data.admin.role)
          : response.data.data.admin.role;
      if (roleNumberType === 4) commit("SET_ROLE_PROGRAM");
    }
  },
  async login({ commit }, payload) {
    const response = await Request.post_data(loginUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      localStorage.setItem("MDR_DASHBOARD_TOKEN", response.data.data.token);
      notiMessage.displayNotiMsg("Welcome Back!");
      commit("CHANGE_LOGGED_IN_STATUS");

      return true;
    }
    errorMessage.displayNotiMsg("login information must be valid");
    return false;
  },
  async logout({ commit }) {
    localStorage.clear();
    commit("resetState");
    return true;
  },
  async changePassword(context, payload) {
    const response = await Request.post_data(changePasswordUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Chaged Password Success!");
      return true;
    }
    return false;
  },
  async getAdmins({ commit }) {
    const response = await Request.get_data(allUrl);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_ADMINS", response);
  },
  async getAdminData({ commit }, id) {
    const response = await Request.get_data(eachUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_ADMIN_DATA", response);
  },
  async createAdmin({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_ADMIN", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    return false;
  },
  async updateAdmin(payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async deleteAdmin({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_ADMIN", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
